import { render } from "./OrderComponentNew.vue?vue&type=template&id=d681aff4&scoped=true"
import script from "./OrderComponentNew.vue?vue&type=script&lang=js"
export * from "./OrderComponentNew.vue?vue&type=script&lang=js"

import "./OrderComponentNew.vue?vue&type=style&index=0&id=d681aff4&scoped=true&lang=css"
import "../../assets/css/staff-editor-dialog.css?vue&type=style&index=1&id=d681aff4&scoped=true&lang=css&external"
import "../../assets/css/staff-order-create-dialog.css?vue&type=style&index=2&id=d681aff4&scoped=true&lang=css&external"
import "../../assets/css/staff-orders-mobile.css?vue&type=style&index=3&id=d681aff4&scoped=true&lang=css&external"
import "../../assets/css/staff-orders-mobile-details.css?vue&type=style&index=4&id=d681aff4&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d681aff4"]])

export default __exports__